import { getIn } from 'seamless-immutable';
import { dispatchEvent } from '../helpers';

export const modalEvent = ({ body }) => {
  const id = getIn(body, ['id']);

  const payload = {
    id,
  };

  dispatchEvent('modal:open', payload);
};
